import React, { useEffect, useState } from "react";
import { Button, Dropdown, Modal, Table } from "react-bootstrap";
import FilterIcon from "../../../../icons/FilterIcon";
import SearchIcon from "../../../../icons/SearchIcon";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import { getClassMonthlyPaymentHistory } from "../../../../services/paymentAndHistory.service";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { getAllSubServices } from "../../../../services/subServices.service";
import { StdioNull } from "child_process";
import { getBookingDetails } from "../../../../services/bookings.service";
import BusinessIcon from "../../../../icons/BusinessIcon";
import CalendarIcon from "../../../../icons/CalendarIcon";
import InfoIcon from "../../../../icons/InfoIcon";
import { getClasslist } from "../../../../services/classes.service";
import { formatBookingTime } from "../../../../utils";

export default function ClassesMonth() {
  const [selectedYear, setSelectedYear] = useState<string>("");
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [selectedClassName, setSelectedClassNAme] = useState<string>("");
  const [params] = useSearchParams();
  const currentYear = new Date().getFullYear();
  const [classMonthlyHistory, setClassMonthlyHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1); // Track current page
  const [totalItems, setTotalItems] = useState<number>(0); // Track total number of items
  const itemsPerPage = 10; // Number of items per page
  const [filterOption, setFilterOption] = useState<string>("newToOld");
  const [selectedService, setSelectedService] = useState("");
  const [subServicelist, setSubServicelist] = useState<any[]>([]);
  const [selectedServiceId, setSelectedServiceId] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [show, setShow] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<any>(null); // To hold selected booking details
  const locationId = localStorage.getItem('locationId');
  const navigate = useNavigate();
  const routes = all_routes;

  const extendedSubServiceList = [
    { _id: null, className: "All" },
    ...subServicelist,
  ];

  const filteredServices = extendedSubServiceList
  .filter((service) =>
    service.className.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSelect = (Service: React.SetStateAction<any>) => {
    setSelectedService(Service?._id);
    if(Service?.className == "All"){
      setSelectedServiceId("All")
      setSelectedClassNAme("All");
    }
    else{
      setSelectedServiceId(Service?._id);
      setSelectedClassNAme(Service?.className);
    }
  };

  let monthArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    const year = params.get("year") || `${currentYear}`;
    const month = params.get("month") || "1";

    setSelectedYear(year);
    setSelectedMonth(month);
    setSelectedServiceId(selectedServiceId || params.get("classId")|| "")
    getClassMonthlyHistory(currentPage, searchTerm, filterOption, selectedServiceId);

    getAllClasses();
  }, [selectedYear, selectedMonth, searchTerm, selectedServiceId]);

  const getClassMonthlyHistory = async (page: number, searchTerm: string, filterOption: string, subServiceId: string) => {
    let skip = (page - 1) * itemsPerPage;

    try {
      const payload:any = {
        className: selectedClassName,
        year: selectedYear,
        month: selectedMonth,
        search: searchTerm,
        sortOrder: filterOption,
        skip,
        limit: itemsPerPage,
      };

      if(selectedServiceId !== "All"){
        payload.classId = subServiceId
        setSelectedClassNAme(params.get("className") || "");
      }
      
      const result = await getClassMonthlyPaymentHistory(payload);
      if (result.status == 200) {
        if (result?.data?.data) {
          setClassMonthlyHistory(result?.data?.data);
        }
      } else if (result.status == 404) {
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.responseMessage);
      }
    }
  };

  const getServices = async () => {
    try {
      const result = await getAllSubServices({});
      setSubServicelist(result?.data?.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllClasses = async () => {
    if (!locationId) return;
    let skip = 0
    try {
        const payload = {
            locationId: locationId,
            sortOrder: 'newToOld',
            skip,
            limit: 1000,
        };
        const result = await getClasslist(payload);
        setSubServicelist(result?.data?.data || []);
    } catch (error) {
        console.error(error);
    }
};

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // Update filter option state
  const handleFilterChange = (filter: string) => {
    setFilterOption(filter);
    setCurrentPage(1);

    getClassMonthlyHistory(currentPage, searchTerm, filter, selectedServiceId);
  };

  const handleShow = async (bookingId: string) => {
    setShow(true);
    
    try {
      const result = await getBookingDetails(bookingId);
      setSelectedBooking(result?.data?.data || null);
    } catch (error) {
      console.error("Failed to fetch booking details:", error);
      setSelectedBooking(null);
    }
  };

  const handleClose = () => {
    setShow(false);
    setSelectedBooking(null);
  };
  // Using centralized date formatting utility
  

  return (
    <>
      <div className="monthWrapper pt-3">
        <div className="container">
          <ul className="breadcrumbWrapper">
            <li>
              <Link to={"/payment-history"}>Payments & History</Link>
            </li>{" "}
            /
            <li>
              <Link
                to={`/payment-history/month?year=${selectedYear}&month=${selectedMonth}`}
              >
                {monthArray[parseInt(selectedMonth) - 1]} {selectedYear}
              </Link>
            </li>
            /
            <li>
              <span>
                {selectedClassName?.charAt(0).toUpperCase() +
                  selectedClassName?.slice(1)}
              </span>
            </li>
          </ul>

          <div className="bgFormColor p-4 my-4">
            <div className="searchTitleWrap d-flex justify-content-between align-items-start">
              <div className="d-flex gap-2 align-items-center flex-wrap">
                <label>
                  {monthArray[parseInt(selectedMonth) - 1]} {selectedYear} -{" "}
                  {selectedClassName?.charAt(0).toUpperCase() +
                    selectedClassName?.slice(1)}
                </label>
                <div className="yearDropdown">
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      {selectedClassName.charAt(0).toUpperCase() +
                        selectedClassName.slice(1) || "Select service"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="searchService">
                        <form>
                          <button>
                            <SearchIcon />
                          </button>
                          <input
                            type="text"
                            placeholder="Search service"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </form>
                      </div>

                      {filteredServices.length > 0 ? (
                        filteredServices.map((service) => (
                          <Dropdown.Item
                            key={service._id || null}
                            onClick={() => handleSelect(service)}
                            className={service?._id === selectedService ? "active" : ""}
                          >
                            {service?.className.charAt(0).toUpperCase() +
                              service?.className.slice(1)}
                          </Dropdown.Item>
                        ))
                      ) : (
                        <Dropdown.Item disabled>No services found</Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <div className="searchWrap d-flex gap-2 align-items-center">
                <form>
                  <button>
                    <SearchIcon />
                  </button>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search check-in ..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </form>

                <div className="filterDropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <FilterIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <button
                        className={filterOption === 'newToOld' ? 'active' : ''}
                        onClick={() => handleFilterChange('newToOld')}
                      >
                        Date, new to old
                      </button>
                      <button
                        className={filterOption === 'oldToNew' ? 'active' : ''}
                        onClick={() => handleFilterChange('oldToNew')}
                      >
                        Date, old to new
                      </button>
                      <button
                        className={filterOption === 'aToZ' ? 'active' : ''}
                        onClick={() => handleFilterChange('aToZ')}
                      >
                        Alphabetically, A-Z
                      </button>
                      <button
                        className={filterOption === 'zToA' ? 'active' : ''}
                        onClick={() => handleFilterChange('zToA')}
                      >
                        Alphabetically, Z-A
                      </button>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table className="tableWrapper">
                <thead>
                  <tr>
                    <th>Class name</th>
                    <th>Booking date time</th>
                    <th>Visitor name</th>
                    <th>Check-in time</th>
                    <th>Status / Action</th>
                  </tr>
                </thead>
                <tbody>
                  {classMonthlyHistory?.length > 0 ? (
                    classMonthlyHistory.map((data: any, index) => (
                      <tr>
                        <td>
                          <span className="underline"> {data?.className.charAt(0).toUpperCase() +
                            data?.className.slice(1)}</span>
                        </td>
                        <td>{data?.bookingDate ? formatBookingTime(data?.bookingDate) : "-"}</td>
                        <td>{`${data?.employeeFirstName.charAt(0).toUpperCase() + data?.employeeFirstName.slice(1)} ${data?.employeeLastName.charAt(0).toUpperCase() + data?.employeeLastName.slice(1)}`}</td>
                        <td>{data?.checkinTime ? formatBookingTime(data?.checkinTime) : '-'}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2 action_result">
                            <span
                              className={
                                (data?.status === "checked-in") || (data?.status === "confirmed") ? "greenText" : data?.status === "not attended" ? "warningText" : data?.status === "cancelled" ? "dangerText" : ""}
                            >
                              {data?.status ? data?.status.charAt(0).toUpperCase() + data?.status.slice(1) : "-"}
                            </span>
                            <button onClick={() => handleShow(data?._id)} className="confirmBtn">Details</button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">
                        No history found for this month.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>

      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className="confirmModal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Booking</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedBooking ? (
            <div>
              <div className="modalImg">
                <img className="w-100" src={"/assets/img/modalImage.jpg"} alt="modalImage" />
              </div>
              <div className="game_content">
                <label>
                  <BusinessIcon /> {" "}
                  <span className="underline">
                    {selectedBooking?.partnerDetails?.businessName ? selectedBooking?.partnerDetails?.businessName : selectedBooking?.partnerDetails?.name}
                  </span>
                </label>
                <h2>{selectedBooking?.className.charAt(0).toUpperCase() + selectedBooking?.className.slice(1)}
                </h2>
                <label className="dateWrap">
                  <CalendarIcon />
                  {selectedBooking?.bookingStartDateTime ? formatBookingTime(selectedBooking?.bookingStartDateTime) : "-"}
                  {" "}
                </label>
                <div className="bgFormColor p-4 my-3">
                  <h3>Booking person details</h3>
                  <div className="bookDetail">
                    <ul>
                      <li className="d-flex justify-content-between"><label>Full name :</label>
                        <h4> {`${selectedBooking?.employeeDetails?.firstName.charAt(0).toUpperCase() + selectedBooking?.employeeDetails?.firstName.slice(1)} ${selectedBooking?.employeeDetails?.lastName.charAt(0).toUpperCase() + selectedBooking?.employeeDetails?.lastName.slice(1)}`}</h4>
                      </li>
                      <li className="d-flex justify-content-between"><label>Email id :</label><h4> {selectedBooking?.employeeDetails?.email}</h4></li>
                      <li className="d-flex justify-content-between"><label>Contact :</label><h4>{selectedBooking?.employeeDetails?.phone}</h4></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p>Loading booking details...</p>
          )}
        </Modal.Body>

        <Modal.Footer className="w-100 direction-column justify-content-center">
        </Modal.Footer>
      </Modal>

    </>
  );
}
